import React from "react";
import MobileMenu from "./MobileMenu";
import UserMenu from "./UserMenu";
import NavigationLinks from "./NavigationLinks";
import { useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { signOut } from "firebase/auth";
import { auth } from "./firebase-config";
import LanguageSwitcher from "./LanguageSwitcher";
import styles from "./UserStatus.module.css";
import { useTranslation } from "react-i18next"; // 추가된 부분

const UserStatus: React.FC = () => {
  const navigate = useNavigate();
  const { userDetails, setLoginOption } = useUser() ?? {};
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language; // 현재 설정된 언어 가져오기
  const handleLogout = async () => {
    await signOut(auth);
    navigate(`/${currentLang}`);
  };

  const handleLogin = () => {
    const loginOption = {
      isRegisterMode: false,
      isTermsOfServiceAgreed: false,
      isPrivacyPolicyAgreed: false,
      userName: "",
      phoneNumber: "",
    };
    setLoginOption?.(loginOption);
    navigate(`/${currentLang}/login`);
  };

  const handleMyPage = () => {
    navigate(`/${currentLang}/myPage`);
  };

  const handleJoinIn = () => {
    navigate(`/${currentLang}/joinIn`);
  };

  const userId = userDetails ? userDetails.id : "Guest";
  const subscriptionType = userDetails ? userDetails.subscriptionType : "-";
  const userLevel = userDetails ? userDetails.userLevel : 9;
  const isAdmin = userId !== "Guest" && userLevel <= 1;
  const handleAdminMembers = () => {
    navigate(`/${currentLang}/admin/members`);
  };
  const handleAdminKnowledge = () => {
    navigate(`/${currentLang}/admin/knowledge`);
  };
  const handleAdminBlog = () => {
    navigate(`/${currentLang}/admin/blog`);
  };

  return (
    <div className={styles.userStatus}>
      <MobileMenu />
      <div className={styles.desktopLinks}>
        <NavigationLinks />
      </div>

      {/* 🔽 오른쪽 정렬용 그룹 */}
      <div className={styles.desktopAccountLinks}>
        <span className={styles.accountName} title={userId}>
          {userId}
        </span>
        {userId !== "Guest" ? (
          <>
            {isAdmin && (
              <>
                <button className={styles.textButton} onClick={handleAdminMembers}>
                  회원관리
                </button>
                <button className={styles.textButton} onClick={handleAdminKnowledge}>
                  지식저장소
                </button>
                <button className={styles.textButton} onClick={handleAdminBlog}>
                  글관리
                </button>
              </>
            )}
            <button className={styles.textButton} onClick={handleMyPage}>
              {t("user_menu.my_page")}
            </button>
            <button className={styles.textButton} onClick={handleLogout}>
              {t("user_menu.logout")}
            </button>
          </>
        ) : (
          <>
            <button className={styles.textButton} onClick={handleLogin}>
              {t("user_menu.login")}
            </button>
            <button className={styles.textButton} onClick={handleJoinIn}>
              {t("user_menu.join")}
            </button>
          </>
        )}
        <LanguageSwitcher />
      </div>

      <div className={styles.rightGroup}>
        {/* 왼쪽: 계정 관리 메뉴 */}

        {/* 가운데: Guest - 타입 */}
        <div className={styles.userDetails}>
          <span title={`${userId} - ${subscriptionType}`}>
            {userId} - {subscriptionType}
          </span>
        </div>

        <UserMenu
          userId={userId}
          userLevel={userLevel}
          subscriptionType={subscriptionType}
          handleLogin={handleLogin}
          handleLogout={handleLogout}
        />

        {/* 맨 오른쪽: Languages 버튼 */}
        <LanguageSwitcher />
      </div>
    </div>
  );
};

export default UserStatus;
